import React from 'react';
import { useTranslation } from 'react-i18next';

import LoadingButton from '../../common/LoadingButton';
import { PetCloudInput } from '../../common/petCloud';
import { maskEmail } from './utils';
import {
  useConfirmRegisteredEmailForm,
} from './hooks/useConfirmRegisteredEmailForm';

import styles from './ConfirmRegisteredEmailScreen.module.css';

const ConfirmRegisteredEmailScreen = ({
  onConfirm = () => { },
  registeredEmail = '',
}) => {
  const { t } = useTranslation('petDemos');

  const {
    email,
    emailError,
    handleEmailBlur,
    handleEmailChange,
    handleSubmit,
  } = useConfirmRegisteredEmailForm({ onConfirm, registeredEmail });

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <p className={styles.subtitle}>
          {t('certificateLinking.confirmRegisteredEmail.subtitle')}
        </p>

        <h1 className={styles.title}>
          {t('certificateLinking.confirmRegisteredEmail.title')}
        </h1>

        <p className={styles.description}>
          {t('certificateLinking.confirmRegisteredEmail.description')}
        </p>
      </div>

      <p className={styles.hint}>
        {t('certificateLinking.confirmRegisteredEmail.hint', {
          email: maskEmail(registeredEmail),
        })}
      </p>

      <div className={styles.inputContainer}>
        <PetCloudInput
          error={emailError}
          errorClassName={styles.emailError}
          inputName="registeredEmail"
          onBlur={handleEmailBlur}
          onChange={handleEmailChange}
          placeholder={t(
            'certificateLinking.confirmRegisteredEmail.placeholder',
          )}
          title={t('certificateLinking.confirmRegisteredEmail.label')}
          type="email"
          value={email}
        />

        <LoadingButton
          className={styles.submitButton}
          onClick={handleSubmit}
          submit={false}
          text={t('certificateLinking.confirmRegisteredEmail.submit')}
        />
      </div>
    </div>
  );
};

export { ConfirmRegisteredEmailScreen };
